<h2><b>Selected Question{{activeQuestionCount == 1 ? '' : 's'}}:</b></h2>

<br>

<p *ngIf="activeQuestionCount == 0">{{'pre-interview-questions.no-questions-selected-message' | translate }}</p>

<div *ngFor="let question of staticQuestionsList">
  <div class="question-container">
    <app-question id="static-question-{{question.questionId}}"
                  [question]="question">
    </app-question>
  </div>
</div>

<div *ngFor="let question of customQuestionsList">
  <div class="question-container">
    <app-question id="custom-question-{{question.questionId}}"
                  [question]="question"
                  [pageState]="pageState">
    </app-question>
  </div>
</div>

<div *ngIf="aiGeneratedFeature">
  <div *ngFor="let question of aiQuestionsList">
    <div class="question-container">
      <app-question id="custom-question-{{question.questionId}}"
                    [question]="question"
                    [pageState]="pageState">
      </app-question>
    </div>
  </div>
</div>
